import type { AssetCode } from '@onyx/shared';

/** The coin's brand colour, shown behind its logo while the image loads. */
export const assetColor = (asset: AssetCode) => `var(--coin-${asset})`;

/** The coin's official logo (public/icons/coins, see its README for sources), clipped to a disc. */
export function AssetChip({ asset, size = 40 }: { asset: AssetCode; size?: number }) {
  return (
    <span className="chip" style={{ width: size, height: size, background: assetColor(asset) }} aria-hidden="true">
      <img src={`/icons/coins/${asset}.svg`} width={size} height={size} alt="" draggable={false} />
    </span>
  );
}
